import script from "./CMF.vue?vue&type=script&lang=js"
export * from "./CMF.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__